import Services from './base-services'

const service = new Services('accessHistory')

export default {
    setLogin(data: any) {
        return service.post('setLogin', data)
    },
    setLogout(data: any) {
        return service.post('setLogout', data)
    },
    setQtys(data: any) {
        return service.put('setQtys', data)
    },
}
